// src/config/nav/defaultNav.js

export const ROLE = {
  ADMIN: 'admin',
  FEDERACION: 'federacion',
  ASOCIACION: 'asociacion',
  ORGANIZADOR: 'organizador',
  CRONOMETRADOR: 'cronometrador',
  JUEZ: 'juez',
  PRENSA: 'prensa',
  ENTRENADOR: 'entrenador',
  ATLETA: 'atleta',
};

/**
 * Cada sección tiene:
 * - id: string único
 * - title: etiqueta visible
 * - iconKey: clave para resolver icono (lo mapeamos en el Sidebar)
 * - items: [{ to, label, iconKey, permissions? }]
 *
 * NOTA: El bloque “Gestión > Eventos” con selector de competencia
 * lo seguimos manejando en SidebarNav (dinámico). Aquí va lo general por rol.
 */
export const DEFAULT_ROLE_NAV = {
  [ROLE.ADMIN]: [
    {
      id: 'admin',
      title: 'Admin',
      iconKey: 'admin',
      items: [
        { to: '/admin/organizadores', label: 'Organizadores', iconKey: 'org' },
        { to: '/admin/cronometradores', label: 'Cronometradores', iconKey: 'timer' },
        { to: '/admin/jueces', label: 'Jueces', iconKey: 'referee' },
        { to: '/admin/eventos', label: 'Eventos', iconKey: 'events' },
        { to: '/admin/equipos', label: 'teams', iconKey: 'teams' },
        { to: '/admin/entrenadores', label: 'Entrenadores', iconKey: 'coach' },
        { to: '/admin/atletas', label: 'Atletas', iconKey: 'athletes' },
      ],
    },
  ],

  [ROLE.FEDERACION]: [
    {
      id: 'federacion',
      title: 'Federación',
      iconKey: 'org',
      items: [
        { to: '/federacion/asociaciones', label: 'Asociaciones', iconKey: 'teams' },
        { to: '/federacion/eventos', label: 'Eventos', iconKey: 'events' },
        { to: '/federacion/rankings', label: 'Rankings', iconKey: 'ranking' },
        { to: '/federacion/records', label: 'Records', iconKey: 'records' },
      ],
    },
  ],

  [ROLE.ASOCIACION]: [
    {
      id: 'asociacion',
      title: 'Asociación',
      iconKey: 'org',
      items: [
        { to: '/asociacion/clubes', label: 'Clubes', iconKey: 'teams' },
        { to: '/asociacion/afiliaciones', label: 'Afiliaciones', iconKey: 'id' },
        { to: '/asociacion/eventos', label: 'Eventos', iconKey: 'events' },
      ],
    },
  ],

  [ROLE.ORGANIZADOR]: [
    {
      id: 'panel',
      title: 'Panel',
      iconKey: 'dashboard',
      items: [
        { to: '/inicio', label: 'Competencias', iconKey: 'dashboard' },
        { to: '/perfil', label: 'Mi Perfil', iconKey: 'account' },
        // “Gestión” (con selector de competencia) va aparte, dinámico.
      ],
    },
  ],

  [ROLE.CRONOMETRADOR]: [
    {
      id: 'cronometraje',
      title: 'Cronometraje',
      iconKey: 'timer',
      items: [
        { to: '/integraciones/modo-manual/gestion', label: 'Modo Manual', iconKey: 'hand' },
        { to: '/integraciones/finishlynx/gestion', label: 'FinishLynx', iconKey: 'lynx' },
        { to: '/en-vivo', label: 'En Vivo', iconKey: 'live' },
      ],
    },
  ],

  [ROLE.JUEZ]: [
    {
      id: 'jueces',
      title: 'Jueces',
      iconKey: 'referee',
      items: [
        { to: '/jueces/asignaciones', label: 'Asignaciones', iconKey: 'assign' },
        { to: '/jueces/tableros', label: 'Tableros', iconKey: 'scoreboard' },
        { to: '/jueces/documentos', label: 'Documentos', iconKey: 'docs' },
      ],
    },
  ],

  [ROLE.PRENSA]: [
    {
      id: 'prensa',
      title: 'Prensa',
      iconKey: 'press',
      items: [
        { to: '/prensa/eventos', label: 'Eventos', iconKey: 'events' },
        { to: '/prensa/resultados', label: 'Resultados', iconKey: 'results' },
        { to: '/prensa/medalleros', label: 'Medalleros', iconKey: 'ranking' },
      ],
    },
  ],

  [ROLE.ENTRENADOR]: [
    {
      id: 'coach',
      title: 'Entrenador',
      iconKey: 'coach',
      items: [
        { to: '/events', label: 'Competencias', iconKey: 'tournament' },
        { to: '/training', label: 'Entrenamientos', iconKey: 'training' },
        { to: '/athletes', label: 'Mis atletas', iconKey: 'athletes' },
      ],
    },
  ],

  [ROLE.ATLETA]: [
    {
      id: 'atleta',
      title: 'Atleta',
      iconKey: 'athletes',
      items: [
        { to: '/events', label: 'Mis competencias', iconKey: 'tournament' },
        { to: '/history', label: 'Mis resultados', iconKey: 'results' },
        { to: '/training', label: 'Entrenamientos', iconKey: 'training' },
      ],
    },
  ],
};
